import { Dialog, DialogTitle, IconButton } from "@mui/material";
import Biodetails from "../bio/Biodetails";
import CloseIcon from '@mui/icons-material/Close';

export default function OpenSettingsCard(props) {
const handleClose = () => {
    props.setSettingsCardOpen(false);
  };
return (
    
     
     
   
    <Biodetails {...props}/>
    
   
)
}